var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 pl-3"},[_c('v-row',{staticClass:"mb-3 mt-5"},[_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.$t("coastsAlerts.title")))])]),_c('v-row',{staticClass:"mb-3",staticStyle:{"width":"90%"}},[_c('span',{staticClass:"text-body-1 mt-2"},[_vm._v(_vm._s(_vm.$t("coastsAlerts.description")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }